export default {
    close: 'Luk',
    dataIterator: {
        pageText: '{0}-{1} af {2}',
        noResultsText: 'Ingen matchende poster fundet',
        loadingText: 'Henter poster...'
    },
    dataTable: {
        itemsPerPageAllText: 'Rækker pr. side:',
        ariaLabel: {
            sortDescending: ': Sorteret i faldende orden. Aktiver for at fjerne sortering.',
            sortAscending: ': Sorteret i stigende orden. Aktiver for at fjerne sortering.',
            sortNone: ': Ikke sorteret. Aktiver for sorterer i stigende orden.',
        },
    },
    dataFooter: {
        itemsPerPageText: 'Poster pr. sider:',
        itemsPerPageAllText: 'Alle',
        nextPage: 'Næste side',
        prevPage: 'Forrige side',
        firstPage: 'Første side',
        lastPage: 'Sidste side',
    },
    datePicker: {
        itemsSelected: '{0} valgt',
    },
    noDataText: 'Ingen data tilgængelig',
    carousel: {
        prev: 'Forrige',
        next: 'Næste',
    },
    calendar: {
        moreEvents: '{0} flere',
    },
}